import type {
  AttestationDTO,
  DemandeRemboursementDTO,
  FraisDTO,
} from '@/features/api/extranet/dto/Demande/DR'
import type { ContextReglesDR } from './types'
import { addPreBuilder, targetPreBuilder } from '@/features/domaine/moteur-regles'
import { PropertyStatus } from '@/features/domaine/property-status'

import { objectGetValueWithNestedKey } from '@/features/shared/tools'
import type { NestedKeyOf } from '@/features/shared/types'

/* Initalisation des helpers */
export const targetPre = targetPreBuilder<DemandeRemboursementDTO, ContextReglesDR>()
export const addPre = addPreBuilder<DemandeRemboursementDTO, ContextReglesDR>()

export const { quandEstObligatoireFrais, quandEstPresentFrais, quandEstObligatoireAttestation, quandEstPresentAttestation } = (() => {
  const preQuandEstSatus = (...status: PropertyStatus[]) => {
    status = Array.isArray(status) ? status : [status]
    return function <T extends object>(rootPath: NestedKeyOf<DemandeRemboursementDTO>) {
      return function (propPath: NestedKeyOf<T>, regles: Parameters<typeof addPre<T>>[1]) {
        return addPre<T>((_value, parent, globalModel, context) => {
          const index = (objectGetValueWithNestedKey(globalModel, rootPath as any) as any[]).indexOf(parent)
          const metaPath = `status.${rootPath}.${index}.${propPath}.$status`
          const propertyStatus = (objectGetValueWithNestedKey(context, metaPath as any) ??
            PropertyStatus.Optional) as PropertyStatus
          return status.includes(propertyStatus)
        }, regles)
      }
    }
  }
  const preQuandEstObligatoire = preQuandEstSatus(PropertyStatus.Required)
  const preQuandEstPresent = preQuandEstSatus(PropertyStatus.Optional, PropertyStatus.Required)
  return {
    quandEstObligatoireFrais: preQuandEstObligatoire<FraisDTO>('frais'),
    quandEstPresentFrais: preQuandEstPresent<FraisDTO>('frais'),
    quandEstObligatoireAttestation: preQuandEstObligatoire<AttestationDTO>('attestations'),
    quandEstPresentAttestation: preQuandEstPresent<AttestationDTO>('attestations'),
  }
})()
